// extracted by mini-css-extract-plugin
export default {"tab":"Tab-module__tab__ybqXb","content":"Tab-module__content__fHpby"};